import { render, staticRenderFns } from "./AddBreakouts.vue?vue&type=template&id=c306501a&scoped=true&lang=pug"
import script from "./AddBreakouts.vue?vue&type=script&lang=ts"
export * from "./AddBreakouts.vue?vue&type=script&lang=ts"
import style0 from "./AddBreakouts.vue?vue&type=style&index=0&id=c306501a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c306501a",
  null
  
)

export default component.exports